export * from './aside.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/aside/index.ts